import { useState } from "react";
import { Copy, Printer, X } from "lucide-react";
import { toast } from "sonner";

export const CredentialsCard = ({ creds, onClose, home }) => {
  const [copied, setCopied] = useState(false);
  const text = creds.map((c) => `${c.name}\tusername: ${c.username}\tpassword: ${c.password}`).join("\n");
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      toast.success("Logins copied");
    } catch {
      toast("Select the table and copy it manually");
    }
  };
  return (
    <div data-testid="student-credentials-card" className="what-creds">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="font-display text-lg font-semibold text-white">{home ? "New logins for your children" : "New student logins"}</p>
          <p className="text-xs text-amber-300 mt-1">Save or print these now. Passwords are only shown once (you can reset them later).</p>
        </div>
        <button data-testid="close-credentials-btn" onClick={onClose} className="text-slate-500 hover:text-white" aria-label="Close"><X size={16} /></button>
      </div>
      <table className="w-full text-sm mt-4">
        <thead><tr className="text-left text-xs font-mono uppercase tracking-wider text-slate-500"><th className="py-2">Name</th><th>Username</th><th>Password</th></tr></thead>
        <tbody>
          {creds.map((c) => (
            <tr key={c.username} data-testid="credential-row" className="border-t border-white/[0.06]">
              <td className="py-2 text-slate-200">{c.name}</td>
              <td data-testid="credential-username" className="font-mono text-[#D4FF3A]">{c.username}</td>
              <td data-testid="credential-password" className="font-mono text-white">{c.password}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="flex gap-2 mt-4">
        <button data-testid="copy-credentials-btn" onClick={copy} className="what-btn-ghost !py-2 text-sm"><Copy size={14} /> {copied ? "Copied" : "Copy all"}</button>
        <button data-testid="print-credentials-btn" onClick={() => window.print()} className="what-btn-ghost !py-2 text-sm"><Printer size={14} /> Print</button>
      </div>
    </div>
  );
};
